<template><div class="drill-overlay"></div></template>

<script>
export default {
  name: "overlay",
};
</script>

<style lang="scss" scoped>
.drill-overlay {
  position: absolute;
  bottom: 0;
  z-index: -1;
  height: 100vh;
  width: 100vw;
  background-color: var(--source-color-main);
}
</style>
